// extracted by mini-css-extract-plugin
export default {"InternalReminderEventInsight":"_InternalReminderEventInsight--Nx_2L","PermissionIcon":"_PermissionIcon--rR1wM"};